// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useAppcues as _appcues } from "@/use/useAppcues";
import { AppcuesMethods } from "@shared/types/global.ts";
export const appcuesClientImpl: AppcuesMethods = _appcues();
